export default "__VITE_ASSET__a4175ecf__"